<template>
      <div class="eachars-box sevenTop">
      <el-row>
        <el-col :span="12">
          <span class="eachars-title">最近7天TOP10节目集排名</span>
        </el-col>
        <el-col :span="8">
          <span class="eachars-title">最近7天TOP10节目排名</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div id="dayProgramCollect" :style="{width: '90%', height: '300px'}"></div>
        </el-col>
        <el-col :span="12">
          <div id="dayProgram" :style="{width: '90%', height: '300px'}"></div>
        </el-col>
      </el-row>
    </div>
</template>
<script>
import { getProgramGroupPlayRankLimit10ByWeek, getProgramPlayRankLimit10ByWeek } from '@/resource/api/dataAnalysis'
export default {
  props: ['todayOptions'],
  data () {
    return {
      searchParams: {
        createBy: this.$store.state.router.createBySuffix,
        platform: this.$store.state.router.cpcode
      }
    }
  },
  mounted () {
    this.pageInit() // 初始化数据
  },
  methods: {
    pageInit () {
      this.dayProgram() // 最近7天TOP10节目排名
      this.dayProgramCollect()// 最近7天TOP10节目集排名
    },
    dayProgram () { // 最近7天TOP10节目集排名
      getProgramPlayRankLimit10ByWeek().then((res) => {
        if (res && res.code == 1) {
          const xAxis = []
          const series = []
          res.result.forEach(item => {
            series.push(item.programName)
            xAxis.push(item.playCount.toString())
          })
          const myChart = this.$echarts.init(document.getElementById('dayProgram'))
          myChart.setOption({
            // title: {
            //   text: '最近7天TOP10节目集排名',
            //   left: '20%',
            //   top: '5%',
            //   textStyle: { color: '#33343B', fontStyle: 'normal', fontWeight: 500, fontSize: 18 }
            // },
            tooltip: { // 提示框 component
              trigger: 'axis',
              backgroundColor: '#fff',
              textStyle: { color: '#66697', fontSize: 7, lineHeight: 25 },
              axisPointer: { type: 'cross', label: { backgroundColor: '#6a7985' } }
            },
            grid: { right: '20', left: '0', bottom: '15', top: '32', containLabel: true },
            xAxis: [
              {
                type: 'value',
                splitLine: { lineStyle: { type: 'dashed' } },
                axisLine: { show: false, lineStyle: { color: 'rgba(0, 0, 0, 0.45)', width: 1 } }
              }
            ],
            yAxis: [
              {
                nameTextStyle: { fontSize: 14 },
                nameLocation: 'start',
                axisLabel: {
                  interval: 0,
                  margin: 65,
                  width: 80,
                  color: '#33343B',
                  textStyle: { align: 'left', baseline: 'middle' },
                  formatter: function (value) {
                    if (value.length > 4) {
                      return value.substring(0, 4) + '...'
                    } else {
                      return value
                    }
                  }
                },
                axisLine: { lineStyle: { color: '#BFBFBF' } },
                axisTick: { show: false, lineStyle: '#BFBFBF' },
                data: series
              }
            ],
            series: [
              {
                barWidth: '35%',
                type: 'bar',
                data: xAxis,
                itemStyle: {
                  normal: {
                    color: '#81AAFB'
                    // function (params) {
                    //   var colorList = ['#81AAFB', '#81AAFB', '#81AAFB', '#81AAFB', '#818EC4', '#FFB94A', '#FF8232']
                    //   return colorList[params.dataIndex]
                    // }
                  }
                }
              }
            ]
          })
        }
      })
    },
    dayProgramCollect () { // 最近7天TOP10节目集排名
      getProgramGroupPlayRankLimit10ByWeek().then((res) => {
        if (res && res.code == 1) {
          const xAxis = []
          const series = []
          res.result.forEach(item => {
            series.push(item.programName)
            xAxis.push(item.playCount.toString())
          })
          const myChart = this.$echarts.init(document.getElementById('dayProgramCollect'))
          myChart.setOption({
            // title: {
            //   text: '最近7天TOP10节目排名',
            //   left: '20%',
            //   top: '5%',
            //   textStyle: { color: '#33343B', fontStyle: 'normal', fontWeight: 500, fontSize: 18 }
            // },
            tooltip: { // 提示框 component
              trigger: 'axis',
              backgroundColor: '#fff',
              textStyle: { color: '#66697', fontSize: 7, lineHeight: 25 },
              axisPointer: { type: 'cross', label: { backgroundColor: '#6a7985' } }
            },
            grid: { right: '20', left: '-15', bottom: '15', top: '32', containLabel: true },
            xAxis: [
              {
                type: 'value',
                splitLine: { lineStyle: { type: 'dashed' } },
                axisLine: { show: false, lineStyle: { color: 'rgba(0, 0, 0, 0.45)', width: 1 } }
              }
            ],
            yAxis: [
              {
                nameTextStyle: { fontSize: 14 },
                axisLabel: {
                  interval: 0,
                  margin: 65,
                  color: '#33343B',
                  textStyle: { align: 'left', baseline: 'middle' },
                  formatter: function (value) {
                    if (value.length > 4) {
                      return value.substring(0, 4) + '...'
                    } else {
                      return value
                    }
                  }
                },
                axisLine: { lineStyle: { color: '#BFBFBF' } },
                axisTick: { show: false, lineStyle: '#BFBFBF' },
                data: series
              }
            ],
            series: [
              {
                barWidth: '35%',
                type: 'bar',
                data: xAxis,
                itemStyle: {
                  normal: {
                    color: '#81AAFB'
                    // function (params) {
                    //   var colorList = ['#81AAFB', '#81AAFB', '#81AAFB', '#81AAFB', '#818EC4', '#FFB94A', '#FF8232']
                    //   return colorList[params.dataIndex]
                    // }
                  }
                }
              }
            ]
          })
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
  @import "../../../../assets/css/dataAnalysis.less";
</style>
